import React from 'react';

const TitleSection = ({
  title,
  subtitle
}) => {
  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
        {title}
      </h1>
      {subtitle && (
        <p className="text-sm text-gray-500 mt-1">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default TitleSection;
